export default __webpack_public_path__ + "static/flock-offsite-mobile-image-b6829eb605e35f1b0cea49520ee795de.webp";